import { Menu } from "../ui/layout/Menu";
import React from "react";
import { FooterCmp } from "../ui/layout/Footer";
import { PageHeader } from "../ui/ds/PageHeader";

export const Gdpr = () => {
    return (
        <>
            <Menu />
            <PageHeader title="GDPR" subtitle="Ochrana osobních údajů" />

            <div className="max-w-4xl mx-auto px-4 md:px-8 py-8">
                <div className="bg-bg-card rounded-content shadow-card p-6 md:p-8 rules tb-body leading-relaxed text-text-primary">
                    Registrací udělujete souhlas se zpracováním osobních údajů, jméno a emailová adresa, Adamu Šmídovi,
                    Stan. Masara 1331, 75201 Kojetín (dále jen správce) za účelem účasti v soutěži – Neveřejná tipovací soutěž Euro 2024, a to na dobu jednoho roku.
                    <br /><br />
                    Osobní údaje bude správce zpracovávat manuálně i automatizovaně.
                    <br /><br />
                    <strong>Poučení o právech Subjektu údajů</strong> vztahujících se k výše uvedenému souhlasu se zpracováním osobních údajů:
                    Udělení souhlasu je dobrovolné. Tento souhlas můžete kdykoli odvolat, a to pro kterýkoli z výše
                    uvedených účelů zpracování. Odvolání souhlasu je možné provést na{' '}
                    <a href="mailto:info@tipbuddy.cz" className="text-brand-blue hover:underline font-bold">info@tipbuddy.cz</a>.
                    <br /><br />
                    Máte právo přístupu ke svým osobním údajům zpracovávaných Správcem, jejich opravu nebo výmaz, popřípadě
                    omezení zpracování, a právo vznést námitku proti zpracování.
                    <br /><br />
                    Dále máte právo získat od Správce osobní údaje, které se Vás týkají a jež jste Správci
                    poskytnul/poskytla na základě tohoto souhlasu. Správce Vám na základě Vaší žádosti poskytne údaje bez
                    zbytečného odkladu ve strukturovaném, běžně používaném a strojově čitelném formátu nebo je na Vaši
                    žádost poskytne jinému jednoznačně určenému správci. Toto právo se nevztahuje na osobní údaje, které
                    nejsou zpracovávány automatizovaně.
                    <br /><br />
                    Domníváte-li se, že dochází k neoprávněnému zpracování Vašich osobních údajů, můžete se obrátit se
                    stížností na dozorový orgán, kterým je pro území České republiky{' '}
                    <a href="https://www.uoou.cz" target="_blank" rel="noreferrer" className="text-brand-blue hover:underline font-bold">
                        Úřad pro ochranu osobních údajů (www.uoou.cz)
                    </a>.
                </div>
            </div>

            <FooterCmp />
        </>
    );
};
